module.exports = "/ui/3aaa25d7b6a007ca72d0cac22cba0b8b.png";